'use client';

import { c as _c } from "react/compiler-runtime";
import type { PieLabelRenderProps } from 'recharts';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { TemperatureDistributionChartProps } from '../../types/lote.types';
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props: PieLabelRenderProps) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent
  } = props;
  if (typeof cx !== 'number' || typeof cy !== 'number' || typeof midAngle !== 'number' || typeof innerRadius !== 'number' || typeof outerRadius !== 'number' || typeof percent !== 'number') {
    return null;
  }
  if (percent < 0.05) return null;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return <text x={x} y={y} fill="rgb(255, 255, 255)" textAnchor="middle" dominantBaseline="central" fontSize={13} fontWeight={600}>
      {`${(percent * 100).toFixed(0)}%`}
    </text>;
};
export function TemperatureDistributionChart(t0) {
  const $ = _c(18);
  const {
    data
  } = t0;
  const hasData = data.some(_temp);
  if (!hasData) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-full items-center justify-center"><p className="text-body font-body text-subtext-color">Sem dados disponíveis</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== data) {
    t1 = data.map(_temp2);
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const chartData = t1;
  let t2;
  if ($[3] !== data) {
    t2 = data.map(_temp3);
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== chartData || $[6] !== t2) {
    t3 = <Pie data={chartData} cx="50%" cy="50%" labelLine={false} label={renderCustomizedLabel} outerRadius={90} innerRadius={40} fill="rgb(42, 27, 99)" dataKey="value" nameKey="name" strokeWidth={2} stroke="rgb(255, 255, 255)">{t2}</Pie>;
    $[5] = chartData;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Tooltip contentStyle={{
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(229, 229, 229)",
      borderRadius: "8px",
      fontSize: "13px"
    }} />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <div className="flex-1"><ResponsiveContainer width="100%" height="100%"><PieChart>{t3}{t4}</PieChart></ResponsiveContainer></div>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== data) {
    t6 = data.map(_temp4);
    $[11] = data;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="flex items-center justify-center gap-6 pt-2">{t6}</div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="flex h-full flex-col">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp4(item) {
  return <div key={item.name} className="flex items-center gap-2"><div className="h-3 w-3 rounded-full" style={{
      backgroundColor: item.color
    }} /><span className="text-caption font-caption text-subtext-color">{item.name}: {item.value}</span></div>;
}
function _temp3(entry, index) {
  return <Cell key={`cell-${index}`} fill={entry.color} />;
}
function _temp2(d_0) {
  return {
    ...d_0
  } as Record<string, unknown>;
}
function _temp(d) {
  return d.value > 0;
}